export default __webpack_public_path__ + "media/images/menu-icon/business-ad676c261cb1c5324d6cc7a9c3bff625.png";